<form [formGroup]="form" class="ht-form ht-form--auth" (ngSubmit)="onSubmit()">
  <div class="ht-form-item">
    <div class="ht-form-item-title">
      {{ 'auth.login.form.email' | translate }}
    </div>
    <div class="ht-form-item-control">
      <ht-input
        [label]="'auth.login.form.email' | translate"
        type="email"
        formControlName="email"
        fullWidth="true"
      ></ht-input>
    </div>
  </div>
  <div class="ht-form-item">
    <div class="ht-form-item-title">
      {{ 'auth.login.form.password' | translate }}
    </div>
    <div class="ht-form-item-control">
      <ht-input
        [label]="'auth.login.form.password' | translate"
        type="password"
        formControlName="password"
        fullWidth="true"
      ></ht-input>
    </div>
    <div class="help-text">
      <a routerLink="/reset-pwd" [queryParams]="{ email: form.value.email }">
        {{ 'auth.login.form.forgotPassword' | translate }}
      </a>
    </div>
  </div>

  <div class="feedback-wrapper">
    @if (!!error) {
      <div class="error-alert">
        <i class="fa-solid fa-circle-xmark"></i>
        <span>{{ error }}</span>
      </div>
    }

    <button
      ht-button-primary
      type="submit"
      size="large"
      [isLoading]="isSigningIn"
      fullWidth="true"
    >
      {{ 'auth.login.form.signIn' | translate }}
    </button>
  </div>

  <p class="sign-up-text">
    {{ 'auth.login.form.noAccount' | translate }}
    <button ht-button-primary appearance="minimal" routerLink="/signup">{{
      'auth.login.form.signUp' | translate
    }}</button>
  </p>
</form>

<login-ens-modal #ensModal (closed)="onEnsModalClosed()"></login-ens-modal>
